
<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import PedidoForm from './pedido-form'
import PedidoFiltro from '../components/pedido-filtro'
import PedidoImpressao from '../forms/pedido-impressao.vue'
import { apiDownloadPDF, apiEmailPDF, apiORDSmidia, apiDateORDS } from '../shared/api-functions'
import { SysVars } from '../main';
import { formatDate, formatValue } from '../shared/utils';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpedv: '',
            filter: '',
            offset: false,
            monthQuery: '',
            textQuery: '',
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            metadata: this.$store.getters.getEntities.metadata,

            monthFilter: {},

            query: {
                codusuario: null,
                codequipe: null,
                text: null,
                after: null,
                before: null,
                codstatus: null,
            },

            partOptions: [
                {id: 'C', text: 'Cliente'},
                {id: 'F', text: 'Fornecedor'},
                {id: 'T', text: 'Transportadora'}
            ],

            usingFiltros: false,

            paramsFiltro: {
              periodos: [

                {
                  label: "Data Pedido / Orçamento",
                  nome: "dta",
                  varios: false,
                  values:[
                    {
                      data_inicio: null,
                      data_termino: null,
                    }
                  ]
                },
                {
                  label: "Data da validade (Orçamentos)",
                  nome: "dtvalidade",
                  varios: false,
                  values:[
                    {
                      data_inicio: null,
                      data_termino: null,
                    }
                  ]
                },

              ],

              selects: [

                {
                  label:"Dias Validade (Orçamentos)",
                  nome:"diasvalidade",
                  placeholder: "Tipo dias validade",
                  id: null,
                  value:null,
                  value_label:"em até",
                  value_placeholder: "Quantidade de Dias Validade (Orçamentos)",
                  options: [
                    {
                      id: "0",
                      text: "Vencidos",
                    },
                    {
                      id: "1",
                      text: "À vencer",
                    },

                  ]
                },

              ],

              filtros: [
              /*
                {
                  nome: "filial",
                  label: null,
                  url: null,
                  varios: false,
                  values: []
                  },
                {
                  nome: "segmento",
                  label: null,
                  url: null,
                  varios: true,
                  values: [],
                },
                {
                  nome: "grupocliente",
                  label: null,
                  url: null,
                  varios: true,
                  values: [],
                },
                {
                  nome: "estado",
                  label: null,
                  url: null,
                  varios: true,
                  values: []
                },
                */
             ],
            },

            codpedvImpressao: null,
            showImpressao: false
        }
    },
    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        notFound: function () {
            return 'Nenhum pedido encontrado para o período ' + formatDate(this.monthFilter.startDate) + ' a ' + formatDate(this.monthFilter.endDate)
        },

        pedvList: function () {
            return this.$store.getters.getPedvList
        },

        pedvTotal: function () {
           return this.$store.getters.getPedvTotal
        },
        bloqueia_alterar_pedido: function () {
            if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
              return this.$store.getters.getParametrosUsuario.vendas.bloqueia_alterar_pedido
            else
              return false
        },


    },

    watch: {
        pedvTotal: function () {

            //AQUI MONTA O OBJETO PARA A LISTA DE FILTROS DO COMPONENTE filter-list BASEADO NO OBJETO DE TOTAIS CARREGADO DO SERVIDOR

            this.filterList = []
            let total = {}

            let tot = 0

            if (this.pedvTotal.length > 0 && this.pedvTotal[this.pedvTotal.length-1].status == 'TOTAL') {
              tot = this.pedvTotal[this.pedvTotal.length-1].total
            }

            for (let i = 0; i < this.pedvTotal.length; i++) {
               total = {}
                total.label = ''
                total.total = this.pedvTotal[i].total
                total.qt = this.pedvTotal[i].qt
                total.status = this.pedvTotal[i].status
                if (total.status == 'ORCAMENTO') {
                    total.label = 'Orçamentos'
                } else if (total.status == 'PERDIDO') {
                    total.label = 'Orçamentos Perdidos'
                } else if (total.status == 'VENDA') {
                    total.label = 'Vendas'
                } else if (total.status == 'TOTAL') {
                    total.label = 'Total Geral'
                }

                //calcula o % em relacao ao total
                if (tot > 0) {
                    total.perc = total.total / tot * 100
                }

                this.filterList.push({...total})
            }

            this.paramFilterList = { total: this.filterList, selectedStatus: '' }

        },

    },

    filters: {

    },

    methods: {
        scroll () {
          window.onscroll = () => {
            if (this.showForm || this.showImpressao || this.offset || this.nextPage == 0)
              return
            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= (document.documentElement.offsetHeight - 2)

            if (bottomOfWindow) {
              this.offset = true
              this.loadData(true)
            }
            SysVars.scrollPosition = document.documentElement.scrollTop
          }
        },

        notFoundMsg() {
            if (this.query.filtros){
              return 'Nenhum pedido encontrado para o período';
            }else{
              return 'Nenhum pedido encontrado para o período ' + formatDate(this.monthFilter.startDate) + ' a ' + formatDate(this.monthFilter.endDate)
            }
        },

        changeFiltros (filtros) {
            this.query.text = null
            this.query.filtros = filtros
            this.loadData()
        },

        statusColor: function (stpedv, tppedv) {
            let color = 'badge-green'
            if (stpedv == 'C' || stpedv == 'R' || tppedv == 'R') {
                color = 'badge-red'
            } else if (stpedv == 'F') {
                color = 'badge-blue'
            } else if (tppedv == 'O') {
                color = 'badge-orange'
            } else if (tppedv == 'P') {
                color = 'badge-green'
            }
            return color
        },
        handleEditPedido (codpedv, view) {
            //abre a tela de edicao
            if (view){
              this.crud = SysVars.crudView
            }else{
              this.crud = SysVars.crudU //operacao de edicao
            }
            this.codpedv = codpedv //numero do pedido
            this.showForm = true; //exibe o form de manutencao
        },
        handleAction (act, codpedv) {
            if (act == 1) {
                //imprimir
                this.codpedvImpressao = codpedv
                this.showImpressao = true
                this.$nextTick(function () {
                    this.$refs.impressao.print()
                })
            }
            else if (act == 2) {
                //faturar
                this.$router.push('/nf/' + codpedv)
            }
            else if (act == 10) {
                //enviar cobranca
                this.$router.push('/banking?codpedv=' + codpedv)
            }
        },
        handleClosePrint () {
            this.showImpressao = false
        },
        handleNovoPedido () {
            //abre a tela de edicao
            this.crud = SysVars.crudI //operacao de inclusao
            this.codpedv = '';
            this.$store.dispatch('cleanpart')
            this.showForm = true; //exibe o form de manutencao
        },
        closeForm() {
            this.showForm = false
            this.$scrollTo(0)
            this.loadData()
        },
        textSearch(value) {
            //efetua a pesquisa por texto
            //let str = value.toUpperCase()
            // this.filter = '{"$or":[{"nome":{"$like":"%25' + str + '%25"}},{"npedido":{"$like":"%25' + str + '%25"}}]}'
            //this.textQuery = 'text=' + str
            //this.monthQuery = ''
            this.query.text = value.toUpperCase()
            this.query.after = null
            this.query.before = null
            this.query.filtros = null
            this.loadData()
        },
        handleChangeFilter (filter, startDate, endDate) {
            //aplicação do filtro avancado
            // FILTRO ORDS DESABILITADO NESTA LISTA this.filter = filter

            //console.log(startDate)
            //if (startDate && endDate)
            //  this.monthQuery = 'after=' + startDate + '&before=' + endDate
            //else
            //  this.monthQuery = ''
            //this.textQuery = ''
            //this.loadData()
            this.query.after = null
            this.query.before = null
            if (startDate)
              this.query.after = startDate
            if (endDate)
              this.query.before = endDate
            this.query.text = null
            this.query.filtros = null
            this.loadData()

        },
        handleFilterList (status) {
            //CLICK DO FILTER LIST
            if (status === 'TOTAL') {
                this.statusQuery = ''
            } else {
                this.statusQuery = 'status=' + status
            }
            this.loadData()
        },
        async loadData(nottotal) {
            let param = {}
            param.query = ''

            if (this.query.text)
              param.query = param.query + 'text=' + this.query.text + '&'
            if (this.query.after)
              param.query = param.query + 'after=' + this.query.after + '&'
            if (this.query.before)
              param.query = param.query + 'before=' + this.query.before + '&'
            if (this.query.codusuario)
              param.query = param.query + 'usuario=' + this.query.codusuario + '&'
            if (this.query.codequipe)
              param.query = param.query + 'equipe=' + this.query.codequipe + '&'
            if (this.query.codstatus)
              param.query = param.query + 'codstatus=' + this.query.codstatus + '&'
            if (this.statusQuery)
              param.query = param.query + this.statusQuery + '&'
            if (this.offset)
              param.query = param.query + 'poffset=' + this.nextPage + '&'

            param.query = param.query.trim()
            if (param.query.endsWith('&'))
              param.query = param.query.slice(0,-1)

            this.usingFiltros = false
            if (this.query.filtros){
              param.body = JSON.stringify(this.query.filtros);
              this.usingFiltros = true
            }

            // console.log(param)
            this.$store.dispatch('loadPedvList', param)
            this.offset = false

            if (!nottotal)
              this.$store.dispatch('loadPedvTotal', param)

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })

        },
        textST (st, tipo) {
            let text = 'Pedido'
            if (tipo == 'O') {
                text = 'Orçamento'
            } else if (tipo == 'R') {
                text = 'Orçamento Perdido'
                return text
            }
            if (st == 'C') {
                text = text + ' Cancelado'
            } else if (st == 'R') {
                text = text + ' Rejeitado'
            } else if (st == 'A') {
                text = text + ' Em Aprovação'
            } else if (st == 'F') {
                text = text + ' Faturado'
            }
            return text
            // return getText(value, this.metadata.pedv.stpedv)
        },
        textTP (value) {
            var item = this.metadata.pedv.tppedv.options.filter(x => x.id === value);
            if (item.length) { return item[0].text }
        },
        enablePrint (st) {
            return (st === 'P' || st == 'F')
        },
        enableEdit (st, cieloidsuperlink, vendarecebida, tp) {
            let result = false

            if ((st === 'P' || st === 'D') && !(vendarecebida == 'S'))
              result = true

            if ((tp === 'P') && (this.bloqueia_alterar_pedido))
              result = false

            return result
        },
        enableFaturar (st, tp) {
            return (st === 'P' && tp === 'P') //somente pedido pendente
        },
        getActions (item) {
            var moreActions = []
            var act = {}
            if (item.stpedv === 'P') {
                act = { action: 2, label: 'Imprimir/PDF' }
                moreActions.push(act)
                act = { action: 6, label: 'Enviar Email' }
                moreActions.push(act)
            }

            if (item.emitecobranca == 'S') {
                act = { action: 10, label: 'Enviar Cobrança' }
                moreActions.push(act)
            }

            if (moreActions.length > 0) {
                return moreActions
            } else {
                return null
            }
        },

        orcamentoVencido(item){
            return (item.tppedv == 'O' && item.stpedv == 'P' && item.dtvalidade && (new Date(item.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)))
        },

    },

    components: {
        BarList, BarGrid, FilterList, PedidoForm, PedidoFiltro, PedidoImpressao
    },

    mounted () {
        this.query.after = apiDateORDS(this.monthFilter.startDate)
        this.query.before = apiDateORDS(this.monthFilter.endDate, true)
        this.query.text = null
        this.query.filtros = null
        this.loadData()
        this.showForm = false
        this.scroll()
    },

    created () {
        //this.$store.dispatch('clearItemSales')

        //carrega parametros do usuario para bloqueio das tabelas de precos
        this.$store.dispatch('loadParametrosUsuario')

    },


    destroyed () {
        window.onscroll = null
    },


}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm">

            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="false"
                :filter-month="true"
                single-entity="Orçamento/Venda"
                plural-entity="Orçamentos/Vendas"
                :month-filter="monthFilter"
                @search="textSearch"
                @new="handleNovoPedido"
                @refresh="loadData"
                @filter="handleChangeFilter"
                title-search="Pesquise pelo número ou nome do cliente ou cnpj/cpf">
            </bar-list>
            <br>

            <pedido-filtro
                :filter-tipos="false"
                :filter-equipes="true"
                :filter-usuarios="true"
                :filter-status="true"
                :params="paramsFiltro"
                :in-use="usingFiltros"
                :query="query" @change="changeFiltros" @cancel="changeFiltros"></pedido-filtro>

            <filter-list :params="paramFilterList" @select="handleFilterList"></filter-list>

            <div class="default-container">
                <alert v-if="pedvList.length == 0" type="warning" :text="notFoundMsg()"></alert>
                <div class="mainbox" v-for="item in pedvList" v-bind:key="item.codpedv">
                    <!-- <div v-bind:class="[{ 'mark-yellow': (item.stpedv === 'D') }, { 'mark-green': (item.stpedv === 'P') }, { 'mark-red': (item.stpedv === 'C' || item.stpedv === 'R') }]"></div> -->
                    <!-- <div class="mark-gray"></div> -->
                    <div class="box row">
                        <div class="col-md-9 col-8 d-none d-md-block">
                            <div class="row">
                                <div class="col-md-12 col-12">
                                    <span class="lbl-list" v-if="item.tppedv=='P'"> Pedido </span>
                                    <span class="lbl-title-produto" v-if="item.tppedv=='P'"
                                        title="Número do Pedido"> #{{ item.npedido }}</span>
                                    <span class="lbl-list"> Orçamento </span>
                                    <span class="lbl-title-produto" title="Número do Orçamento"> #{{ item.ncotacao }}</span>
                                    <!-- <span class="lbl-title-orcamento" v-if="item.tppedv=='P' && item.ncotacao != null"
                                         title="Número do Orçamento">#{{ item.ncotacao }}</span> -->
                                    <span class="lbl-list px-3"><i class="fa fa-user mr-2"></i> {{ item.nome_usuario }} </span>
                                    <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatDataExtenso }}</span>
                                    <span v-if="item.qtanexo > 0"  class="lbl-list pr-3"><i class="fa fa-paperclip pr-2" aria-hidden="true"></i> {{ item.qtanexo }} anexo(s)</span>
                                    <span v-if="item.stpedv != 'C' && item.status" class="badge badge-yellow ml-2"> {{ item.status }} </span>
                                    <span v-if="item.dtvalidade && item.tppedv=='O' " class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>Validade: {{ item.dtvalidade | formatDataExtenso }}</span>
                                    <span v-if="item.data_leitura" class="badge badge-yellow ml-2" data-toggle="tooltip" data-placement="top" :title="item.data_leitura">Leitura Efetuada</span>
                                    <span v-if="orcamentoVencido(item)" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top" title="Orçamento com data de validade vencida"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Vencido</span>
                                </div>
                                <div class="col-md-12 col-12">
                                    <span class="lbl-title-produto">{{ item.nome }}</span>
                                    <span class="data-list w-100">{{ item.cnpjcpf | formatCNPJCPF }} - {{ item.uf }}</span>
                                    <!-- <span class="data-list">{{ item.codpart }}</span> -->
                                </div>
                                <div class="col-md-6 col-12">
                                    <span class="data-list">R$ <strong>{{ item.totger | formatValue(2) }}</strong></span>
                                </div>
                                <div v-if="item.datanfsync || item.nf" class="col-md-12 col-12">
                                    <label v-if="item.datanfsync" class="lbl-list">Faturado em</label>
                                    <span v-if="item.datanfsync" class="lbl-list">{{ item.datanfsync | formatData }}</span>
                                    <label v-if="item.nf" class="lbl-list">Nota Fiscal</label>
                                    <span v-if="item.nf" class="lbl-list">Serie: {{ item.serienf }}</span>
                                    <span v-if="item.nf" class="lbl-list"> Nr.: {{ item.nf }}</span>
                                    <span v-if="item.chavenfsync" class="lbl-list"> Chave: {{ item.chavenfsync }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-4 d-none d-md-block">
                            <div class="row">
                                <div class="col-md-12">
                                   <span class="badge float-right mb-2" :class="statusColor(item.stpedv, item.tppedv)">{{ textST(item.stpedv, item.tppedv) }}</span>
                                   <span v-if="item.varejo == 'S'" class="badge badge-success float-right mr-2" > Varejo </span>
                                </div>
                                <div class="col align-items-right">
                                        <bar-grid
                                            :options="{barDefault: true, btnView: true, btnEdit: enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: enablePrint(item.stpedv), btnFaturar: false}"
                                            :moreActions="getActions(item)"
                                            @edit="handleEditPedido(item.codpedv)"
                                            @view="handleEditPedido(item.codpedv)"
                                            @print="handleAction(1, item.codpedv)"
                                            @faturar="handleAction(2, item.codpedv)"
                                            @action="handleAction($event, item.codpedv)">
                                        </bar-grid>
                                </div>
                            </div>
                        </div>
                        <!-- MOBILE -->
                        <div class="col-12 d-md-none d-xs-block">
                            <div class="row">
                                <div class="col-12 mb-2">
                                    <span class="lbl-list" v-if="item.tppedv=='P'"> Pedido </span>
                                    <span class="lbl-title-produto" v-if="item.tppedv=='P'" title="Número do Pedido"> #{{ item.npedido }}</span>
                                    <span class="lbl-list" v-if="item.tppedv=='O'"> Orçamento </span>
                                    <span class="lbl-title-produto" v-if="item.tppedv=='O'" title="Número do Orçamento"> #{{ item.ncotacao }}</span>
                                    <span class="lbl-list"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatData }}</span>
                                    <span class="lbl-list"><i class="fa fa-user mr-2"></i> {{ item.nome_usuario }} </span>
                                </div>
                                <div class="col-12 mb-2">
                                    <span class="badge" :class="statusColor(item.stpedv, item.tppedv)">{{ textST(item) }}</span>
                                    <span v-if="item.ecommerce == 'S'" class="badge badge-warning"><i class="fa fa-shopping-basket"></i></span>
                                    <span v-if="item.dtvalidade && item.tppedv=='O'" class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>Validade {{ item.dtvalidade | formatDataExtenso }}</span>
                                    <span v-if="orcamentoVencido(item)" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top" title="Orçamento com data de validade vencida"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>Vencido</span>
                                    <span v-if="item.data_leitura" class="badge badge-yellow ml-2" data-toggle="tooltip" data-placement="top" :title="'Leitura efetuada em ' + item.data_leitura"><i class="fa fa-check" aria-hidden="true"></i></span>
                                </div>
                                <div class="col-12">
                                    <span class="lbl-deal-title d-block">{{ item.nome }}</span>
                                    <span v-if="item.fone1" class="data-list-sm"><i class="fa fa-phone" aria-hidden="true"></i> {{ item.fone1 | formatFone }} </span>
                                    <span v-if="item.email" class="data-list-sm"><i class="fa fa-envelope" aria-hidden="true"></i> {{ item.email }} </span>
                                </div>
                                <div class="col-12 mb-2">
                                    <span class="data-list-sm">R$ <strong>{{ item.totger | formatValue(2) }}</strong></span>
                                    <bar-grid
                                        :options="{barDefault: true, btnView: true, btnEdit: enableEdit(item.stpedv, item.cieloidsuperlink, item.vendarecebida, item.tppedv), btnPrint: enablePrint(item.stpedv), btnFaturar: false}"
                                        :moreActions="getActions(item)"
                                        @edit="handleEditPedido(item.codpedv)"
                                        @view="handleEditPedido(item.codpedv, true)"
                                        @print="handleAction(1, item.codpedv)"
                                        @faturar="handleAction(2, item.codpedv)"
                                        @action="handleAction($event, item.codpedv)">
                                    </bar-grid>
                                </div>
                                <div class="col-12 mb-2">
                                    <span class="badge badge-error mr-2" v-if="appLoja && item.tppedv == 'P' && item.stfraud == '3'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Reprovado Clearsale </span>
                                    <span class="badge badge-success mr-2" v-if="appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.stfraud == '2'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Clearsale </span>
                                    <!-- <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && (!item.cieloidsuperlink)"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Link pagamento Cielo não gerado </span> -->
                                    <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && item.stpedv != 'C' && item.cieloidsuperlink && item.vendarecebida != 'S' && item.vendarecebida != 'N'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Aguardando Pagamento Online </span>
                                    <span class="badge badge-warning mr-2" v-if="appLoja && item.tppedv == 'P' && item.cieloidsuperlink && item.vendarecebida == 'N'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento Não realizado </span>
                                    <span class="badge badge-success mr-2" v-if="appLoja && item.tppedv == 'P' && item.vendarecebida == 'S'"> <i class="fa fa-credit-card mr-2" aria-hidden="true"></i> Pagamento Efetuado </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <pedido-form v-if="showForm" :index="this.codpedv" :crud="this.crud" @closeform="closeForm"></pedido-form>

        <div style="display: none">
            <PedidoImpressao ref="impressao" v-if="showImpressao" :index="codpedvImpressao" @close="handleClosePrint"/>
        </div>
    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms/pedido-list.vue